export namespace CUSTOM_FIELD_TYPE {
    export const TEXT = "text"
    export const DATE = "date"
    export const SINGLE_CHOICE = "single-choice"
    export const MULTI_LINE_TEXT = "multi-line-text"
    export const IMAGE = "image"
    export const FILE = "file"
}

export namespace CUSTOM_FIELD_AVAILABLE_FROM {
    export const INVOICE = "invoices"
    export const RETURN = "returns"
    export const QUOTE = "quotes"
    export const ORDER = "orders"
    export const PERSON = "persons"
    export const ORGANIZATIONS = "organizations"
    export const SUPPLIER = "suppliers"
    export const ALL = "all"
}

export namespace CUSTOM_FIELD_ACCEPTED_FILE_EXTENSIONS {
    export const JPEG = ".jpeg"
    export const JPG = ".jpg"
    export const PNG = ".png"
    export const GIF = ".gif"
    export const TIFF = ".tiff"
    export const WEBP = ".webp"
    export const SVG = ".svg"
    export const PDF = ".pdf"
    export const AI = ".ai"
    export const PS = ".ps"
    export const EPS = ".eps"
    export const PSD = ".psd"
    export const DOC = ".doc"
    export const DOCX = ".docx"
    export const XLS = ".xls"
    export const XLSX = ".xlsx"
    export const PP = ".pp"
    export const PPX = ".ppx"
    export const RTF = ".rtf"
    export const TXT = ".txt"
    export const CSV = ".csv"
    export const VSD = ".vsd"
}



// WEBPACK FOOTER //
// ./src/utils/customField/constants.ts